import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-main.png';

const COLS = [
  {
    heading: 'Platform',
    links: [
      ['Courses', '/courses'],
      ['Blog', '/blog'],
      ['Tools', '/tools'],
    ],
  },
  {
    heading: 'Company',
    links: [
      ['About Us', '/about'],
      ['Contact', '/contact'],
      ['Team', '/about'],
    ],
  },
  {
    heading: 'Legal',
    links: [
      ['Privacy Policy', '/privacypolicy'],
      ['Terms of Service', '/termsofservice'],
    ],
  },
];

const SOCIAL = [
  {
    label: 'WhatsApp',
    href: 'https://whatsapp.com/channel/0029VbC9BpM1XqubBPen3T3H',
    color: '#25D366',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/invfly',
    color: '#0A66C2',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/invfly/',
    color: '#E1306C',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
      </svg>
    ),
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@invfly',
    color: '#FF0000',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
  },
];

const Footer = ({ theme }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="compliance-bar">
          InvFly provides educational content only. We do not offer investment or trading advice. Market participation involves risk. Please consult a SEBI registered advisor before making investment decisions.
        </div>

        <div className="footer-g">
          <div className="footer-brand">
            <Link to="/" className="logo" style={{ marginRight: 0 }}>
              <div style={{
                background: theme === 'dark' ? '#FFFFFF' : 'transparent',
                borderRadius: theme === 'dark' ? '6px' : '0',
                padding: theme === 'dark' ? '3px 6px' : '0',
                display: 'flex', alignItems: 'center',
              }}>
                <img src={logo} alt="InvFly" style={{ height: 40, width: 'auto', objectFit: 'contain' }} />
              </div>
            </Link>
            <p>Structured stock market and financial education for Indian learners. Concept-first. Discipline-driven. No tips.</p>
          </div>

          {COLS.map(col => (
            <div key={col.heading}>
              <div className="footer-h">{col.heading}</div>
              <ul className="footer-links">
                {col.links.map(([label, href]) => (
                  <li key={label}>
                    {href.startsWith('http') ? (
                      <a href={href} target="_blank" rel="noopener noreferrer">{label}</a>
                    ) : (
                      <Link to={href}>{label}</Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Connect — social icons in a horizontal row */}
          <div>
            <div className="footer-h">Connect</div>
            <div className="footer-social-row">
              {SOCIAL.map(({ label, href, icon, color }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-btn"
                  aria-label={label}
                  title={label}
                  style={{ '--social-color': color }}
                >
                  <span className="footer-social-icon">{icon}</span>
                  <span>{label}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-bot">
          <p>© {currentYear} InvFly. All rights reserved.</p>
          <p>Hyderabad, Telangana, India</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
